import classnames from 'classnames';
import type { RichTextFormatter } from '@/domains/core/localization/translate';
import type { LoyaltyLevelName } from '@/generated/graphql/types';
import styles from './formatters.module.scss';
export const formatPercentage = ({
  percentage,
  loyaltyLevelName,
  isMarkFormatterEnabled = false
}: {
  percentage: number;
  loyaltyLevelName: LoyaltyLevelName;
  isMarkFormatterEnabled?: boolean;
}): {
  percentage: number;
  mark: RichTextFormatter;
} => {
  let i = 0;
  return {
    percentage,
    mark: isMarkFormatterEnabled ? (chunks: React.ReactNode[]) => {
      const res = <mark className={classnames(styles.mark, styles[loyaltyLevelName.toLowerCase()])} key={i}>
              {chunks}
            </mark>;
      i += 1;
      return res;
    } : chunks => chunks
  };
};